import { IAddress } from './address';
import { ObjectId } from './base';
import { ICFS } from './cfs';
import { IPoint } from './geo';
import { AssignedUnitShiftStatus, IUnit } from './unit';

export enum UnitShiftStatus {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  BUSY = 'BUSY',
  CLOSED = 'CLOSED',
  ON_CALL = 'ON_CALL',
  SCHEDULED = 'SCHEDULED',
  WAITING = 'WAITING',
}

export interface IAssignedUnitShiftStatusReq {
  status: AssignedUnitShiftStatus;
}

export interface IUnitShiftResourceProfile {
  id: string;
  employmentInformation: {
    title: string;
    badgeNumber: string;
    vehicleName: string;
  };
}

export interface IUnitShiftResource {
  fullName?: string;
  _id: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  type: string;
  profile?: IUnitShiftResourceProfile;
}

export interface IUnitShiftResources {
  users?: IUnitShiftResource[];
  vehicles?: IUnitShiftResource[];
  equipments?: IUnitShiftResource[];
  points?: string[];
  lines?: string[];
  polygons?: string[];
}

export interface IUnitShiftLocation {
  timestamp: string;
  address?: IAddress;
  point: IPoint;
  speed: number;
  heading: number;
  altitude: number;
  ellipsoidal_altitude: number;
}

export interface IUnitShift extends ObjectId, IUnitShiftResources {
  unit: IUnit;
  location?: IUnitShiftLocation | null;
  status: UnitShiftStatus;
  startAt?: string;
  endAt?: string;
  cfs?: ICFS[];
  timestamp?: Date;
  notes?: string;
}

export interface IUnitShiftAssignment extends ObjectId, IUnitShiftResources {
  cfsNumber: string;
  unitShift: IUnitShift;
  status: string;
  createdAt: string;
  unAssignedAt: string;
}
